"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFINITION_PROP_NAMES = void 0;
var DEFINITION_PROP_NAMES;
(function (DEFINITION_PROP_NAMES) {
    DEFINITION_PROP_NAMES["OPTIONS"] = "0";
    DEFINITION_PROP_NAMES["FREE"] = "1";
    DEFINITION_PROP_NAMES["DESCRIPTION"] = "a";
    DEFINITION_PROP_NAMES["MAP_TYPE"] = "b";
    DEFINITION_PROP_NAMES["MAP_OPTIONS"] = "c";
    DEFINITION_PROP_NAMES["URL_SETTINGS"] = "d";
    DEFINITION_PROP_NAMES["ALL_FUNCTIONS"] = "e";
    DEFINITION_PROP_NAMES["APP_PROCESSES"] = "f";
    DEFINITION_PROP_NAMES["RAW_STRING"] = "g";
    DEFINITION_PROP_NAMES["ENTRY_VARS"] = "h";
    DEFINITION_PROP_NAMES["ENTRIES"] = "i";
    DEFINITION_PROP_NAMES["INTERPOLATION"] = "j";
    DEFINITION_PROP_NAMES["PATH_ENTRIES"] = "k";
    DEFINITION_PROP_NAMES["CATCH"] = "l";
    DEFINITION_PROP_NAMES["URL"] = "m";
    DEFINITION_PROP_NAMES["METHOD"] = "n";
    DEFINITION_PROP_NAMES["GET"] = "o";
    DEFINITION_PROP_NAMES["POST"] = "p";
    DEFINITION_PROP_NAMES["THEN"] = "q";
    DEFINITION_PROP_NAMES["QUERY_PARAMS"] = "r";
    DEFINITION_PROP_NAMES["DATA"] = "s";
    DEFINITION_PROP_NAMES["QUERY_METHOD"] = "t";
    DEFINITION_PROP_NAMES["HEADERS"] = "u";
    DEFINITION_PROP_NAMES["DELETE"] = "v";
    DEFINITION_PROP_NAMES["HEAD"] = "w";
    DEFINITION_PROP_NAMES["PUT"] = "x";
    DEFINITION_PROP_NAMES["PATCH"] = "y";
    DEFINITION_PROP_NAMES["PURGE"] = "z";
    DEFINITION_PROP_NAMES["LINK"] = "A";
    DEFINITION_PROP_NAMES["UNLINK"] = "B";
    DEFINITION_PROP_NAMES["NAME"] = "C";
    DEFINITION_PROP_NAMES["CONTENT"] = "D";
    DEFINITION_PROP_NAMES["ARRAY"] = "E";
    DEFINITION_PROP_NAMES["PREDICATE"] = "F";
    DEFINITION_PROP_NAMES["FILTER_PREDICATE"] = "G";
    DEFINITION_PROP_NAMES["VALUE"] = "H";
    DEFINITION_PROP_NAMES["ALLOW_RECURSIVE_OBJECTS"] = "I";
    DEFINITION_PROP_NAMES["ERROR_VALUE"] = "J";
    DEFINITION_PROP_NAMES["OBJECT1"] = "K";
    DEFINITION_PROP_NAMES["OBJECT2"] = "L";
    DEFINITION_PROP_NAMES["PATH"] = "M";
    DEFINITION_PROP_NAMES["OBJECT"] = "N";
    DEFINITION_PROP_NAMES["CODE"] = "O";
    DEFINITION_PROP_NAMES["ARGS"] = "P";
    DEFINITION_PROP_NAMES["TAG"] = "Q";
    DEFINITION_PROP_NAMES["CONTROLS"] = "R";
    DEFINITION_PROP_NAMES["WIDTH"] = "S";
    DEFINITION_PROP_NAMES["IS_NEW"] = "T";
    DEFINITION_PROP_NAMES["WIDTH_VALUE"] = "U";
    DEFINITION_PROP_NAMES["EVENTS"] = "V";
    DEFINITION_PROP_NAMES["FUNCTION_IDS"] = "W";
    DEFINITION_PROP_NAMES["OVEWRITE_CALLBACKS"] = "X";
    DEFINITION_PROP_NAMES["CARD_DATA"] = "Y";
    DEFINITION_PROP_NAMES["CALLBACKS"] = "Z";
    DEFINITION_PROP_NAMES["ANDROID_SUBSCRIPTION_OFFER_TOKEN"] = "aa";
    DEFINITION_PROP_NAMES["ON_VIDEO_LOADED"] = "ab";
    DEFINITION_PROP_NAMES["NOT_DETERMINED"] = "ac";
    DEFINITION_PROP_NAMES["DENIED"] = "ad";
    DEFINITION_PROP_NAMES["AUTHORIZED"] = "ae";
    DEFINITION_PROP_NAMES["PROVISIONAL"] = "af";
    DEFINITION_PROP_NAMES["EPHEMERAL"] = "ag";
    DEFINITION_PROP_NAMES["ANY"] = "ah";
    DEFINITION_PROP_NAMES["KNEX_INTERPOLATION"] = "ai";
    DEFINITION_PROP_NAMES["YES"] = "aj";
    DEFINITION_PROP_NAMES["NO"] = "ak";
    DEFINITION_PROP_NAMES["ERROR"] = "al";
    DEFINITION_PROP_NAMES["SKUS"] = "am";
    DEFINITION_PROP_NAMES["FILE_NAME"] = "an";
    DEFINITION_PROP_NAMES["ON_SUCCESS"] = "ao";
    DEFINITION_PROP_NAMES["ON_ERROR"] = "ap";
    DEFINITION_PROP_NAMES["INTERVAL"] = "aq";
    DEFINITION_PROP_NAMES["FASTEST_INTERVAL"] = "ar";
    DEFINITION_PROP_NAMES["TIMEOUT"] = "as";
    DEFINITION_PROP_NAMES["MAXIMUM_AGE"] = "at";
    DEFINITION_PROP_NAMES["ENABLE_HIGH_ACCURACY"] = "au";
    DEFINITION_PROP_NAMES["DISTANCE_FILTER"] = "av";
    DEFINITION_PROP_NAMES["USE_SIGNIFICANT_CHANGES"] = "aw";
    DEFINITION_PROP_NAMES["ID"] = "ax";
    DEFINITION_PROP_NAMES["OFFER_TOKENS"] = "ay";
    DEFINITION_PROP_NAMES["OFFER_TOKEN"] = "az";
    DEFINITION_PROP_NAMES["BASE_PLAN_ID"] = "aA";
    DEFINITION_PROP_NAMES["OFFER_ID"] = "aB";
    DEFINITION_PROP_NAMES["START"] = "aC";
    DEFINITION_PROP_NAMES["STOP"] = "aD";
    DEFINITION_PROP_NAMES["URI"] = "aE";
    DEFINITION_PROP_NAMES["HEIGHT"] = "aF";
    DEFINITION_PROP_NAMES["FORMAT"] = "aG";
    DEFINITION_PROP_NAMES["QUALITY"] = "aH";
    DEFINITION_PROP_NAMES["ROTATION"] = "aI";
    DEFINITION_PROP_NAMES["EMAIL"] = "aJ";
    DEFINITION_PROP_NAMES["PATH_TO_KEY"] = "aK";
    DEFINITION_PROP_NAMES["IS_CONSUMABLE"] = "aL";
})(DEFINITION_PROP_NAMES || (exports.DEFINITION_PROP_NAMES = DEFINITION_PROP_NAMES = {}));
